import React from "react";

import JobSwmsV3DraggableRescueReadinessQuestionRow from "./JobSwmsV3DraggableRescueReadinessQuestionRow";
import listStyles from "../../../../../SwmsMasters/PreStartQuestions/MethodQuestionsStyle.module.css";

export default function JobSwmsV3RescueReadinessQuestionsList({
  questions = [],
  visibleOrders = [],
  reorderDisabled = false,
  moveQuestionRow = () => {},
  onAfterDropQuestionRow = () => {},
  onOpenEditQuestion = () => {}
}) {
  return (
    <div className={listStyles.MethodQuestionList}>
      {questions.map((question = {}, index) => (
        <JobSwmsV3DraggableRescueReadinessQuestionRow
          key={question.id || `rescue-readiness-question-${index}`}
          question={question}
          index={index}
          visibleOrder={visibleOrders[index]}
          reorderDisabled={reorderDisabled}
          moveQuestionRow={moveQuestionRow}
          onAfterDropQuestionRow={onAfterDropQuestionRow}
          onOpenEditQuestion={onOpenEditQuestion}
        />
      ))}
    </div>
  );
}
